// extracted by mini-css-extract-plugin
module.exports = {"error_main":"ChooseOptionModal_error_main__VQ3eh","error_message":"ChooseOptionModal_error_message__jKZTk","close_error":"ChooseOptionModal_close_error__5I74z"};